import React from "react";
import "../styles/SideBadge.css";
import { FaLinkedinIn } from "react-icons/fa";
import { BsFileEarmarkPdf } from "react-icons/bs"; 

const SideBadge = () => {
  const profilePdfUrl = "https://laxmihospitalityservices.in/Laxmi_Hospitality_Services_Profile.pdf";

  return (
    <div className="side-badge-container">
      <a
        href="https://www.linkedin.com/company/laxmi-hospitality-services/"
        target="_blank"
        rel="noopener noreferrer"
        className="side-badge"
        title="LinkedIn"
      >
        <FaLinkedinIn />
      </a>
      <a
        href={profilePdfUrl}
        download="Laxmi_Hospitality_Services_Profile.pdf" 
        className="side-badge"
        title="Download Profile (PDF)"
      >
        <BsFileEarmarkPdf /> 
      </a>
    </div>
  );
};

export default SideBadge;